export const GET_AUDIT_LISTS = 'GET_AUDIT_LISTS';
export const SET_AUDIT_LISTS = 'SET_AUDIT_LISTS';

export const SET_LOADING = 'SET_LOADING';
export const SET_LOADING_PAGINATION = 'SET_LOADING_PAGINATION';
